import { useSelector } from 'react-redux';
import useRailsCsrfToken from '../useRailsCsrfToken';
import { useEffect, useState } from 'react';
import type { TStencilStore, TSubmittableData } from '../../types/Stencil';

function useSubmittableData() {
  const optInNewsletter = useSelector(
    (state: TStencilStore) => state.submission.optInNewsletter
  );
  const authorEmail = useSelector(
    (state: TStencilStore) => state.submission.authorEmail
  );
  const authorName = useSelector(
    (state: TStencilStore) => state.submission.authorName
  );
  const captionText = useSelector(
    (state: TStencilStore) => state.submission.captionText
  );
  const layoutTemplateName = useSelector(
    (state: TStencilStore) => state.submission.layoutTemplateName
  );
  const originalUuidForPreview = useSelector(
    (state: TStencilStore) => state.submission.originalUuidForPreview
  );
  const pageContentItems = useSelector(
    (state: TStencilStore) => state.submission.pageContentItems
  );
  const remotePreviewImageUrl = useSelector(
    (state: TStencilStore) => state.submission.remotePreviewImageUrl
  );
  const shareWithOthers = useSelector(
    (state: TStencilStore) => state.submission.shareWithOthers
  );

  const csrfToken = useRailsCsrfToken();
  const [submittableData, setSubmittableData] = useState<TSubmittableData>({
    authenticity_token: csrfToken,
    opt_in_newsletter: optInNewsletter,
    stencil: {
      author_name: authorName,
      author_email: authorEmail,
      caption_text: captionText,
      layout_template_name: layoutTemplateName,
      original_uuid_for_preview: originalUuidForPreview,
      page_content_items: JSON.stringify(pageContentItems),
      share_with_others: shareWithOthers,
      preview_attributes: { remote_image_url: remotePreviewImageUrl }
    }
  });

  useEffect(() => {
    setSubmittableData({
      authenticity_token: csrfToken,
      opt_in_newsletter: optInNewsletter,
      stencil: {
        author_name: authorName,
        author_email: authorEmail,
        caption_text: captionText,
        layout_template_name: layoutTemplateName,
        original_uuid_for_preview: originalUuidForPreview,
        page_content_items: JSON.stringify(pageContentItems),
        share_with_others: shareWithOthers,
        preview_attributes: { remote_image_url: remotePreviewImageUrl }
      }
    });
  }, [
    authorEmail,
    authorName,
    captionText,
    csrfToken,
    layoutTemplateName,
    optInNewsletter,
    originalUuidForPreview,
    pageContentItems,
    remotePreviewImageUrl,
    shareWithOthers
  ]);

  return submittableData;
}

export default useSubmittableData;
